import { IonFabButton, IonFab, IonIcon, IonList, IonRefresherContent, IonRefresher, useIonViewWillEnter, useIonRouter, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { addOutline } from 'ionicons/icons';

import { showAlert, showConfirm } from '../components/Alert';
import NServer, { UIElement } from "../components/NServer";
import Vault from '../components/Vault';
import { LANGUAGE, GetStr } from "../language/Language";
import ItemComp from "../components/ItemComp";
import { ItemInfo } from "../data/item";

import './Main.css'; 

interface ChannelListProp extends RouteComponentProps<{
    type : string
    }> 
{}

const ChannelList : React.FC<ChannelListProp> = ({match}) => {
    
    const [channels, setChannels] = useState<ItemInfo[]>([]);

    //	Initializing our router
	const router = useIonRouter();

    useIonViewWillEnter(() => {
        getData();
    });

    const doRefresh = async (ev : any) => {
        await getData();
        ev.detail.complete();
    };

    const getData = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key
        }

        var server = new NServer();
        await server.getList("nc_channels", state);
        if (!server.success && server.message != "")
        {
            showAlert(server.message);
            return;
        }

        setChannels(server.data.channels);
    }

    // update the main channel
    const setMainChannel = async (channel : number) => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            channel: channel
        }

        var server = new NServer();
        await server.sendForm("nc_main_channel", state);
        if (!server.success && server.message != "")
        {
            showAlert(server.message);
            return;
        }

        router.push("/studio", "back", "pop");
    }

    // click on item
    const onClick = (item : ItemInfo) => {
        if (match.params.type == "select")
        {
            setMainChannel(item.id);
        }
        if (match.params.type == "edit")
        {
            router.push("/channel_info/" + item.id, "forward", "push");
        }
    }

    return (
        <IonPage>
            <IonHeader>
                <IonItem lines="none"></IonItem>
            </IonHeader>
            <IonContent>
                <div id="border-bk" />
                <IonRefresher  slot="fixed" onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                <div className="ion-padding-start ion-padding-top">
                    { GetStr(LANGUAGE.TXT_CHANNEL_LIST) }
                </div>
                <IonCard>
                    <IonList>
                        {channels.map(m => <ItemComp key={m.id} item={m} onSubmit={onClick} />)}
                    </IonList>
                </IonCard>
                {
                    match.params.type == "edit" ?
                <IonFab vertical="bottom" horizontal="end" slot="fixed">
                    <IonFabButton routerLink="/new_channel/-1">
                        <IonIcon icon={addOutline} />
                    </IonFabButton>
                </IonFab>
                    :
                <div/>
                }
            </IonContent>
        </IonPage>
    );
};

export default ChannelList;